export default __webpack_public_path__ + "static/King-15c9bf760ef726983a52cef66a584d2e.svg";